import Vue from 'vue'
import App from './App.vue'
import CustomPlugin from './plugin/index'
import router from './router/index.js'
import request from "./axios"
import less from 'less'
import ElementUI from 'element-ui'  //引入element-ui库
import VFormRender from '@public/cdn/vform/VFormRender.umd.min.js'//'vform-builds/dist/VFormRender.umd.min.js'  //引入VFormRender组件

import 'element-ui/lib/theme-chalk/index.css'  //引入element-ui样式
//import 'vform-builds/dist/VFormRender.css'  //引入VFormRender样式
import '@public/cdn/vform/VFormRender.css'

import "./assets/icon/iconfont.css"
import "./assets/icon/logoIcon/iconfont.css"
import "./assets/style/css/common.css"

import VueHtml5Plus from 'vue-html5plus';

Vue.config.productionTip = false


window.vformUploadUrlPrefix = process.env.VUE_APP_BASEURL

Vue.use(less)
Vue.use(ElementUI)  //全局注册element-ui
Vue.use(VFormRender)  //全局注册VFormRender等组件
/* 注意：如果你的项目中有使用axios，请用下面一行代码将全局axios复位为你的axios！！ */
Vue.use(CustomPlugin)
Vue.use(VueHtml5Plus);

// function browserRedirect() {
//   var sUserAgent = navigator.userAgent.toLowerCase();
//   if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
//     //跳转移动端页面
//     console.log('移动端');
//     //this.mobileStatus = mobile(页面通过data的mobileStatus 值做不同样式)
//   } else {
//     //跳转pc端页面
//     console.log('PC端');
//      //this.mobileStatus = pc
//   }
// }
// browserRedirect();

new Vue({
  router,
  created: () => {
    const loadSDK = function(src){
      let head = document.getElementsByTagName("head")[0]
      let script = document.createElement("script")
      script.type = "text/javascript"
      script.onload = script.onreadystatechange = function () {
        if (
          !this.readyState ||
          this.readyState === "loaded" ||
          this.readyState === "complete"
        ) {
          script.onload = script.onreadystatechange = null
        }
      }
      script.src = src
      head.appendChild(script)
    }
    loadSDK("https://mapchang.com/3d/build/CGSJsSDKLoader.min.js")
    loadSDK("https://mapchang.com/2d/build/CGSMapSDKLoader.min.js")
    loadSDK("https://mapchang.com/earth/build/CGSGlobeSDKLoader.min.js")
    
  },
  render: h => h(App)
}).$mount('#app')
